import type { IProjectGridRow, IScopeElement } from '@app/types';

export function prepareScopeElementUpdate(projectGridRow: IProjectGridRow): IScopeElement {
  return { ...projectGridRow, children: [], costDistribution: [] };
}
